<script setup lang="ts">
const { isLoading } = useLoading();
</script>

<template>
  <div v-show="isLoading" class="w-full overflow-hidden h-2 z-100 sticky top-0">
    <span class="block bg-transparent">
      <span class="progress block bg-(--ui-primary) p-0.5 relative" />
    </span>
  </div>
</template>

<style scoped>
@reference "../assets/css/main.css";

@keyframes loader {
  0% {
    width: 0;
    left: 0;
  }

  10% {
    width: 25%;
    left: 12%;
  }

  50% {
    width: 50%;
    left: 25%;
  }

  90% {
    width: 25%;
    left: 62%;
  }

  100% {
    width: 0;
    left: 100%;
  }
}


.progress {
  animation: loader 2s linear infinite;
}
</style>
